import { render, staticRenderFns } from "./CIYun.vue?vue&type=template&id=012b537c&scoped=true&"
import script from "./CIYun.vue?vue&type=script&lang=js&"
export * from "./CIYun.vue?vue&type=script&lang=js&"
import style0 from "./CIYun.vue?vue&type=style&index=0&id=012b537c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b537c",
  null
  
)

export default component.exports